import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import {
  Sc4FailedMessagesExportSetInitialState,
  Sc4FailedMessagesExportStart,
} from './sc4-failed-messages-export.actions';
import { FailedMessagesExportFacadeInterface, Sc4FailedMessagesListSearchCriteria } from '../../models';
import { ListSearchCriteriaFacade } from '../../../../list-search-criteria/list-search-criteria.facade';
import { ListSearchCriteriaType } from '../../../../list-search-criteria/constants/list-search-criteria-type.constant';
import { ExportDialogComponent } from '../../../../../../ui-kit/export-dialog';

@Injectable({ providedIn: 'root' })
export class Sc4FailedMessagesExportFacade implements FailedMessagesExportFacadeInterface {
  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
  ): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Sc4FailedMessages)
      .subscribe((searchCriteria: Sc4FailedMessagesListSearchCriteria) => {
        this.store.dispatch(
          new Sc4FailedMessagesExportStart({
            searchCriteria,
            reportName,
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new Sc4FailedMessagesExportSetInitialState());
  }
}
